import { ContentType } from "@seneca/course-service-types";
import { Box } from "@seneca/senekit";

import { Var } from "features/common/localisation";
import enrichSectionTextWithContentTypeTag from "features/hardestQuestions/utils/enrichSectionTextWithContentTypeTag";

import styles from "./RowTitle.module.scss";

type Props = {
  title: string;
  contentType?: ContentType | null;
  dataTestName?: string;
};

export default function RowTitle({ title, contentType, dataTestName }: Props) {
  return (
    <Box dataTest={dataTestName} lineHeight="140%" className={styles.wrapper}>
      <Var>
        {enrichSectionTextWithContentTypeTag({
          text: title,
          contentType
        })}
      </Var>
    </Box>
  );
}
